export default __webpack_public_path__ + "static/Colors-1dce91b37f0e454b972389db1ec2d93b.png";